import type { Transition } from 'lumen/services/transition';

const SNAPSHOT_PATHS = [
  'summary',
  'forecast',
  'pickup',
  'transient-group',
  'daily-summary',
  'booking-pace',
  'heatmap',
  'reservation-activity',
];

const DAY_BY_DAY_PATHS = [
  'strategy',
  'market-segments',
  'rate-plans',
  'length-of-stay',
  'room-type',
  'last-year-and-forecast',
  'group-and-events',
  'str',
];

const REVPAK_PATHS = [
  'str-analysis',
  'annual-summary',
  'pickup',
  'outlook',
  'segments',
  'end-date',
  'event-strategy',
  'media-recap',
  'property-details',
  'other-notes',
];

const EXECUTIVE_PATHS = [
  'annual-summary',
  'snapshot',
  'forecast',
  'pickup',
  'transient-group',
  'budget',
  'last-year',
  'segment-drilldown',
  'heatmap',
] as const;

// follows the order from Spider
const HOTEL_SETTINGS_TABS = [
  {
    path: 'admin',
    featureFlag: 'spider.settings.hotel_admin',
  },
  {
    path: 'settings',
    featureFlag: 'spider.settings.hotel_settings',
  },
  {
    path: 'assignments',
    featureFlag: 'spider.settings.hotel_glance_recipients',
  },
  {
    path: 'rate-shop',
    featureFlag: 'spider.settings.rate_shop',
  },
  {
    path: 'rate-plans',
    featureFlag: 'spider.settings.rate_plan_mappings',
  },
  {
    path: 'workflow',
    featureFlag: 'spider.settings.workflows',
  },
];

const PORTFOLIO_SETTINGS_PATHS = [
  'admin',
  'settings',
  'market-segments',
  'users',
  'brand-market-segments',
  'property-tags',
];

export {
  DAY_BY_DAY_PATHS,
  EXECUTIVE_PATHS,
  HOTEL_SETTINGS_TABS,
  PORTFOLIO_SETTINGS_PATHS,
  REVPAK_PATHS,
  SNAPSHOT_PATHS,
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const resetIdQueryParams = (transition: Transition) => {
  const { queryParams } = transition.to;

  [
    'hotelIds',
    'portfolioIds',
    'brandParentIds',
    'brandIds',
    'customTagFilters',
    'dormIds',
    'otaiDormIds',
    'regionalDosIds',
    'otaiRegionalDosIds',
    'regionalVpIds',
    'otaiRegionalVpIds',
    'classes',
    'ownerships',
    'portfolioRegions',
    'regions',
    'cities',
  ].forEach((key) => {
    queryParams[key] = undefined;
  });

  return queryParams;
};
